<div class="row flex-gap-3"
     [ngClass]="alignClasses">

  <div *ngFor="let icon of storageList"
       class="col-auto text-center">
    <img class="gsw-storages-img"
         [src]="icon.path"
         [alt]="icon.name"
         [title]="icon.name" />
  </div>

</div>
